// @ts-check
import InsuranceCoverageForm from './InsuranceCoverageForm';

export default InsuranceCoverageForm;
